import { render, staticRenderFns } from "./Cables.vue?vue&type=template&id=ef510a3a&scoped=true"
import script from "./Cables.vue?vue&type=script&lang=js"
export * from "./Cables.vue?vue&type=script&lang=js"
import style0 from "./Cables.vue?vue&type=style&index=0&id=ef510a3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef510a3a",
  null
  
)

export default component.exports